import { Component, Inject } from "@angular/core";
import { BV_DIALOG_DATA, BvDialogRef } from "../../design-system";

import { BvDialogTitleComponent, BvDialogBodyComponent, BvDialogFooterComponent } from "../../design-system/primitives/dialog.component";
import { BvButtonComponent } from "../../design-system/primitives/button.component";

export interface AlertDialogData {
  title?: string;
  message: string;
  closeButton?: string;
}

@Component({
    selector: "app-alert-dialog",
    templateUrl: "./alert-dialog.component.html",
    styleUrls: ["./alert-dialog.component.scss"],
    imports: [BvDialogTitleComponent, BvDialogBodyComponent, BvDialogFooterComponent, BvButtonComponent]
})
export class AlertDialogComponent {
  constructor(
    public dialogRef: BvDialogRef<AlertDialogComponent>,
    @Inject(BV_DIALOG_DATA) public data: AlertDialogData
  ) {}

  onClose(): void {
    this.dialogRef.close();
  }
}